import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useCandleWorkersApi } from 'pages/hooks/useCandleWorkersApi';

import { Card } from 'components/cards/Card';
import { Page } from 'components/page/Page';

import { CandleWorkersGrid } from './components/CandleWorkersGrid';

export default () => {
  const { search } = useLocation();
  const { getData } = useCandleWorkersApi();
  useEffect(() => {
    getData();
  }, [getData, search]);
  return (
    <Page title="Candle Workers">
      <Card>
        <CandleWorkersGrid />
      </Card>
    </Page>
  );
};
